import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0032',
    ecrans: ['00-2']    
});
